import React from 'react'
import { sendDataDogError } from './datadog-init'

type Props = { children: any }

class ErrorBoundary extends React.Component<Props> {
  componentDidCatch(error: any) {
    sendDataDogError(error, { errorType: `ErrorBoundary` })
    throw error
  }

  render() {
    return this.props.children
  }
}

export default ErrorBoundary
